interface Option {
  value: string | number;
  label: string;
}

interface SegmentedTabsProps {
  options: Option[];
  value: string | number;
  onChange: (value: string | number) => void;
  ariaLabel?: string;
}

export default function SegmentedTabs({ options, value, onChange, ariaLabel }: SegmentedTabsProps) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className="inline-flex flex-wrap items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200"
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.value)}
            className={`rounded-full px-3.5 py-1.5 text-sm font-label tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
              active ? "bg-accent-500 text-background-50" : "text-foreground-600 hover:text-foreground-900 hover:bg-background-200/60"
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}